import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=7044ec2f&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"
import style0 from "./Banner.vue?vue&type=style&index=0&id=7044ec2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7044ec2f",
  null
  
)

export default component.exports